
        import { sdk } from 'https://esm.sh/@farcaster/miniapp-sdk';

        function isLikelyMiniAppShell() {
            try {
                if (window.parent !== window) return true;
                if (window.ReactNativeWebView) return true;
            } catch (e) {
                return true;
            }
            const ua = (navigator.userAgent || '').toLowerCase();
            const ref = (document.referrer || '').toLowerCase();
            return ua.includes('warpcast') || ua.includes('farcaster') ||
                ref.includes('warpcast.com') || ref.includes('farcaster.xyz');
        }

        function stayOnMiniApp() {
            document.body.classList.add('stay', 'react-ready');
            document.documentElement.classList.add('react-ready');
        }

        (async () => {
            try {
                if (window.shouldBypassRedirect && window.shouldBypassRedirect()) {
                    stayOnMiniApp();
                    return;
                }
                
                const currentPath = window.location.pathname;
                if (currentPath === '/desktop' || currentPath === '/desktop.html' || 
                    currentPath === '/mobile' || currentPath === '/mobile.html' ||
                    currentPath === '/baseapp' || currentPath === '/baseapp.html') {
                    stayOnMiniApp();
                    return;
                }

                const likely = isLikelyMiniAppShell();
                let isMini = likely;
                try {
                    isMini = (await sdk.isInMiniApp(3000)) || likely;
                } catch (e) {
                    isMini = likely;
                }

                if (isMini) {
                    try {
                        const context = await sdk.context;
                        const isBaseApp = context?.client?.clientFid === 309857;
                        if (isBaseApp) {
                            window.location.replace('/baseapp.html?v=' + Date.now());
                            return;
                        }
                    } catch (contextError) {}

                    stayOnMiniApp();
                    try {
                        await sdk.actions.ready({ disableNativeGestures: true });
                    } catch (readyErr) {}
                    return; 
                }

                const userAgent = navigator.userAgent.toLowerCase();
                const isMobile = /android|iphone|ipad|mobile|tablet/.test(userAgent);
                if (isMobile) { 
                    window.location.replace('/mobile'); 
                } else { 
                    window.location.replace('/desktop'); 
                }
            } catch (error) {
                stayOnMiniApp();
                try { await sdk.actions.ready({ disableNativeGestures: true }); } catch (e) {}
            }
        })();
    